function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".container" + shadowSelector + " {height: 132px;min-width: var(--temp-min-width);z-index: 100;position: sticky;top: 0;}.container.editor-header" + shadowSelector + " {margin-top: 266px;}.notification-container" + shadowSelector + " {margin-top: 20px;right: 40px;position: fixed;z-index: 952;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];